import * as React from 'react';
// import {MAX_BOUNDS, MAX_BOUNDS_ZOOMED} from "../../utils/maxBounds";
import {IViewPort} from '../../store/types';
import {initViewport} from '../../utils/initViewport';

const ViewportContext = React.createContext<{viewport: IViewPort, setViewport: any} | undefined>(undefined);

// const isOutOfMaxBounds = (latitude: number, longitude: number, maxBounds: number[][]) => {
//     const [[swLng, swLat], [neLng, neLat]] = maxBounds;
//     return longitude < swLng || longitude > neLng || latitude < swLat || latitude > neLat;
// };

function ViewportProvider(props: any) {
    const [viewport, setViewport] = React.useState(initViewport);
    const value = React.useMemo(() => {
        return {
            viewport,
            setViewport,
        };
    }, [viewport]);
    return <ViewportContext.Provider value={value} {...props} />;
}

function useViewport() {
    const context = React.useContext(ViewportContext);
    if (!context) {
        throw new Error('useViewport must be used within a ViewportProvider');
    }
    const {viewport, setViewport} = context;
    const updateViewport = React.useCallback((vp) => {
        // const minZoom = initViewport.zoom - 1;
        // const maxBounds = vp.zoom < 4 ? MAX_BOUNDS : MAX_BOUNDS_ZOOMED;
        //
        // if ((!vp.zoom || vp.zoom >= minZoom) &&
        //     !isOutOfMaxBounds(vp.latitude, vp.longitude, maxBounds)) {
        setViewport({...viewport, ...vp});
        // }
    }, [viewport, setViewport]);
    return {
        viewport,
        setViewport,
        updateViewport,
    };
}

export {ViewportProvider, useViewport};
